import * as React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Checkbox, Grid, ListItemText, Switch, FormControlLabel } from '@material-ui/core';
import { INVALID_REGION_ERROR, REGION_EMPTY_ERROR } from 'src/constants/NotificationMessageConstant';
import { ALLOWED_MULTISELECT_ROLE_IDS } from '../../constants/constants';
import { UserType } from '../../constants/Enum/UserType';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export default class UserDetailsComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            regionArray: this.props.editUser.regionIds ? this.getSelectedRegionArray(this.props.editUser.regionIds, this.props.editUser.regions) : []
        }
    }

    // get the selected regions list from the id's of regions
    getSelectedRegionArray = (regionIds: any, regionList: any) => {
        const selectedRegions: any = [];
        regionList.forEach((region: any, regionIndex: number) => {
            if (regionIds.includes(region.id)) {
                selectedRegions.push(region.name)
            }
        })

        return selectedRegions
    };

    handleStatusChange = (event: any) => {
        const updatedUser = this.props.editUser;
        if (event.target.name === "Status") {
            updatedUser.isActive = !updatedUser.isActive;
        }
        else {
            updatedUser.isQuestionReviewRequired = this.props.editUser.isQuestionReviewRequired == null ? false : !updatedUser.isQuestionReviewRequired;
        }
        this.props.updateUserDetails(updatedUser);
    }

    handleOrganizationChange = (event: any) => {
        const updatedUser = this.props.editUser;
        updatedUser.organization = event.target.value;
        this.props.updateUserDetails(updatedUser);
    }

    // handle change event of role dropdown
    handleRoleChange = (event: any) => {
        const updatedUser = this.props.editUser;
        updatedUser.roleId = event.target.value;
        updatedUser.regionIds = []
        this.setState({
            regionArray: [],
            selectedRegionIds: []
        }, () => {
            this.props.updateUserDetails(updatedUser);
        })
    }

    // handle change event of region dropdown
    handleRegionChange = (event: any, regionList: any) => {
        const regionArray = event.target.value
        const selectedRegionIds: any = [];
        this.setState({ regionArray }, () => {
            regionList.forEach((region: any) => {
                if (Array.isArray(regionArray) && regionArray.includes(region.name)) {
                    selectedRegionIds.push(region.id)
                } else if (!Array.isArray(regionArray)) {
                    const regionId = regionList.length > 0 ? regionList.find((x: { name: string; }) => x.name === regionArray).id : 0
                    if (regionId > 0 && selectedRegionIds.length === 0) {
                        selectedRegionIds.push(regionId);
                    }
                }
            })

            const updatedUser = this.props.editUser;
            updatedUser.regionIds = selectedRegionIds;
            this.props.updateUserDetails(updatedUser);
        });
    };

    // if selected values is array then join it with , to show in dropdown field
    renderArrayValue = (selected: any) => {
        return Array.isArray(selected) ? selected.join(', ') : selected;
    }

    // display checked checkboxes if selected region matches
    isChecked = (regionName: string) => {
        if (Array.isArray(this.state.regionArray)) {
            return this.state.regionArray.indexOf(regionName) > -1
        }

        return this.state.regionArray === regionName
    }

    render() {
        return (
            <Grid container={true} spacing={24}>
                <Grid item={true} xs={6}>
                    <Grid container={true} spacing={8}>
                        <Grid item={true} xs={12}>
                            <div>
                                <FormControl margin="normal" required={true} fullWidth={true}>
                                    <InputLabel htmlFor="firstName">First Name </InputLabel>
                                    <Input id="firstName"
                                        name="firstName"
                                        value={this.props.editUser && this.props.editUser.firstName || ''}
                                        placeholder="First Name"
                                        fullWidth={true}
                                    />
                                </FormControl >
                            </div>
                        </Grid>
                        <Grid item={true} xs={12}>
                            <div>
                                <FormControl margin="normal" required={true} fullWidth={true}>
                                    <InputLabel htmlFor="lastName">Last Name </InputLabel>
                                    <Input id="lastName"
                                        name="lastName"
                                        value={this.props.editUser && this.props.editUser.lastName || ''}
                                        placeholder="Last Name"
                                        fullWidth={true}
                                    />
                                </FormControl >
                            </div>
                        </Grid>
                        <Grid item={true} xs={12}>
                            <div>
                                <FormControl margin="normal" required={true} fullWidth={true}>
                                    <InputLabel htmlFor="organization">Organization </InputLabel>
                                    <Input id="organization"
                                        name="organization"
                                        value={this.props.editUser && this.props.editUser.organization || ''}
                                        placeholder="Organization"
                                        onChange={this.handleOrganizationChange}
                                        fullWidth={true}
                                        readOnly={this.props.editUser.isInternalUser}
                                    />
                                    {!this.props.isOrganizationValid && <span className="errorMessage">Organization can't be empty.</span>}
                                </FormControl >
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item={true} xs={6}>
                    <Grid container={true} spacing={8}>
                        <Grid item={true} xs={12}>
                            <div><span>Status : </span>
                                <Switch checked={this.props.editUser.isActive === true}
                                    onChange={this.handleStatusChange}
                                    color="primary"
                                    name="Status"
                                />
                            </div>
                        </Grid>
                        <Grid item={true} xs={12}>
                            <div><span>UserType : </span> {this.props.editUser.nutriDashUserType}</div>
                        </Grid>
                        <Grid item={true} xs={12}>
                            <FormControl fullWidth={true}>
                                <InputLabel htmlFor="role">Assign Role</InputLabel>
                                <Select
                                    value={this.props.editUser ? (this.props.editUser.roleId ? this.props.editUser.roleId : '') : ''}
                                    onChange={this.handleRoleChange}
                                    input={<Input name="role" id="age-auto-width" />}
                                    autoWidth={true}>
                                    <MenuItem key={0} value={0}>Select</MenuItem>
                                    {
                                        this.props.editUser.roles &&
                                        this.props.editUser.roles.map((mt: any, index: any) => {
                                            return <MenuItem key={index} value={mt.key}>{mt.value}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item={true} xs={12}>
                            <div />
                        </Grid>
                        <Grid item={true} xs={12}>
                            <div><span>Email : </span>{this.props.editUser.email}</div>
                        </Grid>
                        {
                            (ALLOWED_MULTISELECT_ROLE_IDS.includes(this.props.editUser.roleId)) &&
                            <Grid item={true} xs={12}>
                                <FormControl fullWidth={true}>
                                    <InputLabel htmlFor="select-multiple-checkbox">Region</InputLabel>
                                    <Select
                                        name='region'
                                        multiple={this.props.userId === 1 && ALLOWED_MULTISELECT_ROLE_IDS.includes(this.props.editUser.roleId) ? true : false}
                                        value={this.state.regionArray}
                                        onChange={(event) => this.handleRegionChange(event, this.props.editUser.regions)}
                                        input={<Input id="select-multiple-checkbox" />}
                                        renderValue={(selected: any) => ALLOWED_MULTISELECT_ROLE_IDS.includes(this.props.editUser.roleId) && this.state.regionArray.length > 0 ? this.renderArrayValue(selected) : selected}
                                        MenuProps={MenuProps}
                                    >
                                        {
                                            this.props.editUser.regions.map((region: any) => (
                                                <MenuItem key={region.id} value={region.name} >
                                                    { ALLOWED_MULTISELECT_ROLE_IDS.includes(this.props.editUser.roleId) && <Checkbox checked={this.isChecked(region.name)} />}
                                                    <ListItemText className={this.props.userId === 1 && ALLOWED_MULTISELECT_ROLE_IDS.includes(this.props.editUser.roleId) ? 'muliti-checkbox-margin-left' : ''} primary={region.name} />
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                    {!this.props.isRegionValid && <span className="errorMessage">{REGION_EMPTY_ERROR}</span>}
                                    {!this.props.isMultipleRegions && <span className="errorMessage">{INVALID_REGION_ERROR}</span>}

                                </FormControl>
                            </Grid>}
                        {this.props.editUser.roleId === 2 &&
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isQuestionReviewRequired"
                                        onChange={this.handleStatusChange}
                                        color="primary"
                                        disabled={this.props.userId === UserType.RegionalAdmin}
                                        defaultChecked={this.props.editUser.isQuestionReviewRequired == null ? true : this.props.editUser.isQuestionReviewRequired}
                                    />
                                }
                                label="Questions created/modified by this user must undergo review"
                            />
                        }
                    </Grid>
                </Grid>
            </Grid >
        )
    }
}






// WEBPACK FOOTER //
// ./src/components/users/UserDetailsComponent.tsx